import {
  CODING_STATS_FAILURE,
  CODING_STATS_SUCCESS,
  GET_CATEGORY_FAILURE,
  GET_CATEGORY_SUCCESS,
  GET_LANGUAGES_FAILURE,
  GET_LANGUAGES_SUCCESS,
  GET_LEVEL_CONTENT_FAILURE,
  GET_LEVEL_CONTENT_SUCCESS,
  GET_SUB_LEVEL_CONTENT_FAILURE,
  GET_SUB_LEVEL_CONTENT_SUCCESS,
  SUGGESTION_FAILURE,
  SUGGESTION_SUCCESS,
} from "./code.actionTypes";

const initialState = {
  languages: null,
  category: null,
  content: null,
  subLevel: null,
  suggestion: null,
  coding_stats: null
};

export default function codeReducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_LANGUAGES_SUCCESS:
      return {
        ...state,
        languages: payload,
      };
    case GET_LANGUAGES_FAILURE:
      return {
        ...state,
        message: "",
      };

         case GET_CATEGORY_SUCCESS:
      return {
        ...state,
        category: payload,
      };
    case GET_CATEGORY_FAILURE:
      return {
        ...state,
        message: "",
      };

      case GET_LEVEL_CONTENT_SUCCESS:
      return {
        ...state,
        content: payload,
      };
    case GET_LEVEL_CONTENT_FAILURE:
      return {
        ...state,
        message: "",
      };

      case GET_SUB_LEVEL_CONTENT_SUCCESS:
      return {
        ...state,
        subLevel: payload,
      };
    case GET_SUB_LEVEL_CONTENT_FAILURE:
      return {
        ...state,
        message: "",
      };

    case SUGGESTION_SUCCESS:
      return {
        ...state,
        suggestion: payload,
      };
    case SUGGESTION_FAILURE:
      return {
        ...state,
        message: "",
      };

    case CODING_STATS_SUCCESS:
      return {
        ...state,
        coding_stats: payload,
      };
    case CODING_STATS_FAILURE:
      return {
        ...state,
        message: "",
      };

    default:
      return state;
  }
}
